import React from 'react';

function ShortT() {
  return <div></div>;
}

export default ShortT;
